import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Protocols } from "@/components/Protocols";
import { Testimonials } from "@/components/Testimonials";
import { ChapterShowcase } from "@/components/ChapterShowcase";
import { AuthorNote } from "@/components/AuthorNote";
import { EmailCapture } from "@/components/EmailCapture";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { StickyBar } from "@/components/StickyBar";

const Index = () => {
  return (
    <div className="min-h-screen bg-void overflow-x-hidden">
      <Hero />
      <Manifesto />
      <Protocols />
      <Testimonials />
      <ChapterShowcase />
      <AuthorNote />
      <EmailCapture />
      <FAQ />
      <FinalCTA />
      <StickyBar />
    </div>
  );
};

export default Index;
